<p-sidebar  [(visible)]="visible" class="ss-g-custom-sidebar-width ss-l-class-metaApp" position="right" (onHide)="onClose()" [modal]="!isMobile">
    <ng-template pTemplate="header" [modal]="false">
        <h4 class="mb-0">Apps > Shopify</h4>
    </ng-template>
    <div class="sidebar-content">
        <app-feed-help [text]="'Shopify'" class="" [videoUrl]="'https://youtube.com/video-tutorial'"
            [supportUrl]="'https://meusite.com/suporte'">
        </app-feed-help>
        <!-- novo layout -->
        <ng-container *ngIf="!loading; else sidebarSkeleton">
        <ng-container *ngIf="connected; else installArea">
            <div class="card shadow-none">
                <div class="text-900 text-xl font-semibold mb-4">Loja ativa</div>
                <div class="card shadow-none relative">
                    <!-- ✅ Botão no canto superior direito da `card` do usuário -->
                    <button pButton pRipple type="button" icon="pi pi-times"
                        class="p-button-sm p-button-primary text-sm"
                        style="position: absolute; top: -0.5rem; right: -0.5rem; width: 1.75rem; height: 1.75rem; border-radius: 4px; z-index: 10;    padding: 0;"
                        (click)="disconnect.emit(); $event.preventDefault()">
                    </button>

                    <div class="flex align-items-center justify-content-between mb-2">
                        <div class="flex align-items-center gap-2 ">
                            <app-og-card [platform]="'shopify'" [shopUrl]="'https://' + selectedStoreApp?.form_value?.domain">
                            </app-og-card>
                            <!-- <app-og-card [platform]="'shopify'" shopUrl="https://www.koreessentials.com/">
                            </app-og-card> -->
                            
                        </div>
                    </div>


                </div>
            </div>
        </ng-container>


        <!-- Área de instalação (quando !connected) -->
        <ng-template #installArea>
            <div class="card cursor-pointer border-dashed border-1 surface-border flex flex-column justify-content-center align-items-center ss-g-hover-border2 text-center shadow-none"
                style="height:160px;" (click)="connect.emit()">
                <img src="assets/shopify_glyph.png" alt="Shopify Icon" width="36" class="mb-3" />
                <span class="font-medium">Instalar aplicativo SHOPIFY</span>
                <span class="text-sm text-500">Instale nosso app em sua loja Shopify</span>
            </div>
        </ng-template>
        </ng-container>

        <ng-template #sidebarSkeleton>
            <div class="card shadow-none">
                <p-skeleton width="8rem" height="1.5rem" styleClass="mb-4"></p-skeleton>
                <div class="flex align-items-center gap-2">
                    <p-skeleton shape="circle" size="2rem"></p-skeleton>
                    <div class="flex-1">
                        <p-skeleton width="60%" height="1rem" styleClass="mb-1"></p-skeleton>
                        <p-skeleton width="40%" height="0.75rem"></p-skeleton>
                    </div>
                </div>
            </div>
            <p-skeleton width="100%" height="160px"></p-skeleton>
        </ng-template>
        <!-- novo layout -->




    </div>

    <ng-template pTemplate="footer">
        <div style="text-align: right;">
            <button pButton pRipple label="Fechar" (click)="onClose()" class="p-button-outlined "></button>
            <!-- <button pButton pRipple label="Upload" [loading]="loadingBtn" (click)="uploadSave()" [disabled]="uploadOn"
                class="ml-2 mr-2"></button> -->

        </div>
    </ng-template>

</p-sidebar>